import { render, staticRenderFns } from "./message-edit.vue?vue&type=template&id=6f425fdc&scoped=true"
import script from "./message-edit.vue?vue&type=script&lang=js"
export * from "./message-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f425fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f425fdc')) {
      api.createRecord('6f425fdc', component.options)
    } else {
      api.reload('6f425fdc', component.options)
    }
    module.hot.accept("./message-edit.vue?vue&type=template&id=6f425fdc&scoped=true", function () {
      api.rerender('6f425fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/settings/message-edit.vue"
export default component.exports